<template>
  <div class="badge">{{ value }}</div>
</template>

<script>
export default {
  props: {
    value: String,
  },
  data() {},
};
</script>
